<button routerLink="/camera-supervision" mat-raised-button class="btn">
  <mat-icon>chevron_left</mat-icon>
  {{ 'BACK_TO_CAMERA_SUPERVISION' | translate }}
</button>
<div class="col-md-6 offset-md-3">
  <h4>{{ 'CAMERA_SUPERVISION_SETTINGS' | translate }}</h4>
  <p>{{ 'CAMERA_SUPERVISION_SETTINGS_DESCRIPTION' | translate }}</p>
  <!-- Camera selection container -->
  <div class="card-body">
    <div class="content" style="background-color: #FFFFFF;">
      <div class="flex space-between">
        <h5>{{ 'SELECT_CAMERAS' | translate }}</h5>
      </div>
      <div class="flex space-between display-block">
        <div class="col-md-4">
          <!-- <div>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'SEARCH_CAMERAS' | translate }}</mat-label>
            <mat-hint>{{ 'SEARCH_FOR_ID_OR_NAME' | translate }}</mat-hint>
            <input matInput type="text">
            <button matSuffix mat-icon-button>
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div> -->
        <div class="mt-3">
          {{'SELECT_CAMERA_BY_CLICK' |translate}}
          @for (group of visibleCameraGroups; track group) {
            <div
              class="pt-2"
              [class.disabled]="group.disabled"
              >
              <span
                class="cursorPointer"
                [ngClass]="{'text-success': group.selected, 'text-muted': group.disabled}"
                (click)="!group.disabled && selectCameraGroup(group)"
                [style.pointer-events]="group.disabled ? 'none' : 'auto'"
                [style.opacity]="group.disabled ? 0.5 : 1"
                >
                <span class="fa-light fa-fw fa-video"></span>
                {{ group.displayName }}
                @if (group.selected) {
                  <span class="text-success fa-light fa-fw fa-check"></span>
                }
              </span>
            </div>
          }
        </div>
      </div>
      @if (selectedCameraGroups.length > 0) {
        <div class="col-md-8">
          <form [formGroup]="newVisitForm" (ngSubmit)="formSubmitSubject.next()">
            <div class="form-group">
              <mat-form-field>
                <mat-label>{{'WEEKDAY' |translate}}</mat-label>
                <mat-select formControlName="visitWeekDay" multiple>
                  @for (weekday of weekdays; track weekday) {
                    <mat-option [value]="weekday.id">
                      {{weekday.name |translate}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field class="example-full-width">
                <mat-label>{{'DATE_FROM' |translate}}</mat-label>
                <input matInput type="time" value="08:00" formControlName="visitStartTime">
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field class="example-full-width">
                <mat-label>{{'VISIT_DURATION' |translate}}</mat-label>
                <input matInput type="number" value="120" formControlName="visitDuration">
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field class="example-full-width">
                <mat-label>{{'EXTENSION_TIME' |translate}}</mat-label>
                <input matInput type="number" value="15" formControlName="visitExtensionTime" [disabled]="nightowlSelected">
              </mat-form-field>
              <mat-icon matTooltip="{{ 'EXTENSION_TIME_TOOLTIP' | translate }}" [hidden]="nightowlSelected">info</mat-icon>
            </div>
            <div class="form-group">
              <button mat-stroked-button class="btn" type="button" (click)="cancelVisitCreation()">
                <mat-icon>cancel</mat-icon>
                {{'CANCEL' | translate }}
              </button>
              <button [disabled]="!newVisitForm.valid" type="submit" mat-raised-button color="primary"
                class="btn margin-left">
                <mat-icon>save</mat-icon>
                {{ 'SAVE' | translate }}
              </button>
            </div>
            <div class="form-group">
              @if (savingInProgress) {
                <div class="alert alert-info mt-2"><span
                class="fa-light fa-spinner fa-spin"></span> {{'SAVING_DATA' |translate}}</div>
              }
              @if (savingDone) {
                <div class="alert alert-success mt-2"><span
                class="fa-light fa-check"></span> {{'UPDATE_SUCCESS' |translate}}</div>
              }
            </div>
          </form>
        </div>
      }
    </div>
    @if (!cameraGroups) {
      <div class="col-md-8">
        <img class="fadeLoader centerLoader logoSmall" src="assets/img/loading_logo.svg" />
      </div>
    }
  </div>
</div>
</div>
